import { AxiosResponse } from "axios";
import { normalize, schema } from 'normalizr';
import { createAsyncThunk } from "@reduxjs/toolkit";
import stickerMakerApi from '../../api/stickerMakerApi';
import stickerMakerUrls from "../../configs/sticker_maker/stickerMakerUrls";
import { CategoryInterface } from "../../store/sticker_maker/categoriesSlice";

const PREFIX = 'sticker_maker';

const processStrategy = (value: any) => {
  return {
    ...value,
    image_url: stickerMakerUrls.remoteUrl(value.image_url)
  };
}

const categoriesEntity = new schema.Entity(
  'categories',
  {},
  {
    processStrategy
  }
);

const categoryEntity = new schema.Entity(
  'category',
  {},
  {
    processStrategy
  }
);

const normalizeInstance = (response: AxiosResponse) => {
  const normalized = normalize<any, { category: CategoryInterface }>(response.data.category, categoryEntity);
  return normalized.entities;
}

export const fetchCategories = createAsyncThunk(
  `${PREFIX}_categories/fetchCategories`,
  async (params: object = {}) => {
    const response = await stickerMakerApi.get(`/onesky/categories`, { params })
    const normalized = normalize(response.data, [categoriesEntity]);

    return {
      categories: normalized.entities.categories || {},
      ids: normalized.result
    };
  }
);

export const fetchCategory = createAsyncThunk(
  `${PREFIX}_categories/fetchCategory`,
  async (id: number) => {
    const response = await stickerMakerApi.get(`/onesky/categories/${id}`)

    return normalizeInstance(response);
  }
);

export const createCategory = createAsyncThunk(
  `${PREFIX}_categories/createCategory`,
  async (data: object, { rejectWithValue }) => {
    try {
      const response = await stickerMakerApi.post(`/onesky/categories`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error?.response?.data || error);
    }
  }
);

export const updateCategory = createAsyncThunk(
  `${PREFIX}_categories/updateCategory`,
  async ({ id, data }: { id: number, data: object }, { rejectWithValue }) => {
    try {
      const response = await stickerMakerApi.patch(`/onesky/categories/${id}`, data)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const destroyCategory = createAsyncThunk(
  `${PREFIX}_categories/destroyCategory`,
  async (id: number) => {
    const response = await stickerMakerApi.delete(`/onesky/categories/${id}`)

    return response.data;
  }
);

export const destroyImage = createAsyncThunk(
  `${PREFIX}_categories/updateCategory`,
  async ({ id }: { id: number }, { rejectWithValue }) => {
    try {
      const response = await stickerMakerApi.delete(`/onesky/categories/${id}/image`)

      return normalizeInstance(response);
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);

export const reorderCategories = createAsyncThunk(
  `${PREFIX}_categories/reorderCategories`,
  async ({ ids }: { ids: any }, { rejectWithValue }) => {
    try {
      await stickerMakerApi.patch('/onesky/categories/reorder', { ids })

      return { ids };
    } catch (error: any) {
      return rejectWithValue(error.response.data || error)
    }
  }
);
